import React from 'react'
import styled from 'styled-components'
import useScreen from '../utils/useScreen'

interface MainMenuLayoutProps {
  menu: React.ReactElement
  content: React.ReactElement
}

export const MainMenuLayout: React.FC<MainMenuLayoutProps> = ({ menu, content }) => {
  const { md } = useScreen()

  const renderForMD = () => {
    return (
      <>
        {menu}
        <FlexRow>
          <ContentCard>{content}</ContentCard>
        </FlexRow>
      </>
    )
  }

  const renderForLG = () => {
    return (
      <FlexRow>
        <MenuColumn>{menu}</MenuColumn>

        <ContentCard>{content}</ContentCard>
      </FlexRow>
    )
  }

  if (md) {
    return renderForMD()
  } else {
    return renderForLG()
  }
}

const FlexRow = styled.div`
  display: flex;
`

const MenuColumn = styled.div`
  width: 250px;
  margin-right: 16px;
`

const ContentCard = styled.div`
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`
